<template>
  <div class="relative" v-click-outside="closeBody">
    <!-- head -->
    <Dropdown
      :label="label"
      :valueT="valueT"
      :value="value"
      v-bind="$attrs"
      v-on="$listeners"
    />
    <!-- body -->
    <div
      v-show="value"
      class="absolute z-50 min-w-full max-w-xs md:max-w-sm bg-AkWhite shadow p-4"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import Dropdown from './Dropdown.vue'

export default {
  name: 'DropdownWithBody',
  components: { Dropdown },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    value: {
      type: Boolean,
      default: false
    },
    valueT: {
      type: String,
      default: 'Sélectionner'
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    closeBody () {
      this.$emit('input', false)
    }
  }
}
</script>
